import { useRef } from "react";
import { noop, uniqueId } from "lodash";
import { t } from "@/i18n-js/instance";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";
import type { OnSubmitFunction } from "@circle-react-shared/uikit/Form/Form";
import { Form } from "@circle-react-uikit/Form";
import { createTemplateValidationSchema } from "./validationSchema";

const localeNamespace = "settings.emails.templates";

const defaultValue = { name: "" };

export const CreateTemplateModalComponent = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { current: formId } = useRef(uniqueId("template_name_"));
  const nameInputRef = useRef<HTMLInputElement>(null);

  const handleSubmit: OnSubmitFunction<typeof defaultValue> = () => {
    /** @TODO Implement the logic to create template */
    noop();
    onClose();
  };

  return (
    <ConfirmationModal
      formId={formId}
      isOpen={isOpen}
      onClose={onClose}
      title={t([localeNamespace, "save_template"])}
      confirmVariant="circle"
      confirmText={t([localeNamespace, "save_template"])}
      disabled={false}
      initialFocusRef={nameInputRef}
    >
      <Form
        id={formId}
        mode="onChange"
        validationSchema={createTemplateValidationSchema}
        defaultValues={defaultValue}
        onSubmit={handleSubmit}
      >
        <Form.Item
          name="name"
          translationRoot={localeNamespace}
          label={t([localeNamespace, "template_name"])}
          hideDescription
          hidePlaceholder
          hideBorder
        >
          <Form.Input ref={nameInputRef} />
        </Form.Item>
      </Form>
    </ConfirmationModal>
  );
};
